// Finar Ö1 — framework süzgeci seçenekleri. Etiket `frameworkName versionNumber`; çerçeve
// adlarında tekillik olmadığı için iki seçenek aynı etiketi alabilir ("TSRS 2 v1" ×2).
// Çakışan etiketlere yayın tarihi, o da yetmezse sürüm kimliğinin kısa öneki eklenir.
import { type PublishedFrameworkEntry } from "@mahir/shared";

export interface FrameworkOption {
  value: string;
  label: string;
}

function formatShortDate(iso: string | null): string | null {
  if (!iso) return null;
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return null;
  return d.toLocaleDateString("tr-TR", { day: "2-digit", month: "2-digit", year: "numeric" });
}

function countLabels(labels: string[]): Map<string, number> {
  const counts = new Map<string, number>();
  for (const l of labels) counts.set(l, (counts.get(l) ?? 0) + 1);
  return counts;
}

export function buildFrameworkOptions(entries: PublishedFrameworkEntry[]): FrameworkOption[] {
  const base = entries.map((f) => `${f.frameworkName} ${f.version.versionNumber}`);
  const baseCounts = countLabels(base);
  const dated = entries.map((f, i) => {
    const label = base[i]!;
    if ((baseCounts.get(label) ?? 0) < 2) return label;
    const date = formatShortDate(f.version.publishedAt ?? f.version.createdAt);
    return date ? `${label} · yayın ${date}` : label;
  });
  const datedCounts = countLabels(dated);
  return entries.map((f, i) => {
    const label = dated[i]!;
    const unique = (datedCounts.get(label) ?? 0) < 2;
    return {
      value: f.version.id,
      label: unique ? label : `${label} · #${f.version.id.slice(0, 6)}`,
    };
  });
}
